import src from "IMAGE";
export default { src, width: 408, height: 262, blurWidth: 0, blurHeight: 0};
